import { TuiNotificationService } from "@taiga-ui/core";
import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from '../../features/auth/services/auth.service';
import { showUnauthorizedAlert } from '../utils/alert-helper.util';

export const authGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const alerts = inject(TuiNotificationService);

  // Capture trigger synchronously — getCurrentNavigation() is null once async resolves.
  const trigger = router.getCurrentNavigation()?.trigger;

  return authService.ensureValidSession().pipe(
    map((valid): boolean | UrlTree => {
      if (valid) return true;
      showUnauthorizedAlert(alerts, 'unauthenticated', {
        sessionExpiredRecently: authService.sessionExpiredRecently(),
      });
      if (trigger === 'imperative') {
        return false;
      }
      return router.createUrlTree(['/home']);
    }),
  );
};
